<template>
  <!-- Multi-CNPJ: seletor da empresa ativa (só aparece para quem gerencia mais de uma) -->
  <div v-if="empresas.length > 1" class="dropdown nav-item empresa-ativa-select">
    <a href="javascript:;" id="ddlEmpresaAtiva" data-bs-toggle="dropdown" aria-expanded="false"
       class="btn nav-link d-flex align-items-center" title="Empresa ativa">
      <!-- prédio -->
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-briefcase">
        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
      </svg>
      <span class="empresa-nome ms-2 d-none d-md-inline text-truncate">{{ nomeEmpresaAtiva }}</span>
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
           class="feather feather-chevron-down ms-1">
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </a>

    <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="ddlEmpresaAtiva"
        style="min-width: 320px; max-width: 380px;">
      <li class="px-3 py-2 border-bottom">
        <div class="d-flex justify-content-between align-items-center">
          <strong>Empresa ativa</strong>
          <AjudaBotao :slug="AJUDA_SLUGS.SISTEMA_EMPRESA_ATIVA" variante="popup" titulo="Ajuda: empresa ativa" />
        </div>
        <div class="small text-muted">As ações do sistema serão feitas com a empresa selecionada.</div>
      </li>
      <li v-for="emp in empresas" :key="emp.cnpj">
        <a href="javascript:;" class="dropdown-item d-flex flex-column align-items-start py-2"
           :class="{ 'active': ehAtiva(emp), 'disabled text-muted': !emp.temBanco }"
           @click.stop="selecionaEmpresa(emp)">
          <div class="d-flex w-100 justify-content-between align-items-center">
            <span class="fw-bold text-truncate" style="max-width: 240px;">{{ emp.razaosocial }}</span>
            <span v-if="emp.titular" class="badge badge-primary ms-2">Titular</span>
            <span v-else-if="!emp.temBanco" class="badge badge-warning ms-2">Sem ambiente</span>
          </div>
          <small :class="ehAtiva(emp) ? '' : 'text-muted'">{{ maskCNPJ(emp.cnpj) }}</small>
        </a>
      </li>
      <li class="px-3 py-2 border-top">
        <router-link to="/configs/central" class="small text-primary">Central de Empresas</router-link>
      </li>
    </ul>
  </div>
</template>

<script setup>
import AjudaBotao from '@/components/AjudaBotao.vue';
import { AJUDA_SLUGS } from '@/config/ajudaEngage';
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { listaEmpresas, ativarEmpresa } from '@/stores/empresasStore';
import { showConfirm, showLoading, closeLoading, showToast, maskCNPJ } from '@/mixins/fcgeral';

const store = useStore();
const empresas = ref([]);

const cnpjAtivo = computed(() => store.getters.cnpjAtivo);
const nomeEmpresaAtiva = computed(() => {
  const emp = empresas.value.find(e => e.cnpj === cnpjAtivo.value);
  return emp?.nomefantasia || emp?.razaosocial || store.getters.razaoSocialAtiva;
});

const ehAtiva = (emp) => emp.cnpj === cnpjAtivo.value;

const selecionaEmpresa = async (emp) => {
  if (!emp.temBanco || ehAtiva(emp)) return;

  const confirma = await showConfirm(
    'question',
    'Trocar de empresa?',
    `O sistema passará a operar como ${emp.razaosocial} (${maskCNPJ(emp.cnpj)}). A página será recarregada.`
  );
  if (!confirma) return;

  showLoading('Ativando empresa...');
  const json = await ativarEmpresa(emp.cnpj);
  closeLoading();
  if (!json.ok) return; // a mensagem de erro já foi exibida pela camada de API

  if (json.data.titular) {
    store.commit('setEmpresaAtiva', null);
  } else {
    store.commit('setEmpresaAtiva', {
      cnpj: json.data.cnpj,
      razaosocial: json.data.razaosocial,
      nomefantasia: json.data.nomefantasia,
      lanceweb: json.data.lanceweb,
    });
  }
  // Persiste as licenças da empresa ativa em userDados (sobrevivem ao reload);
  // cnpj/razaosocial de userDados permanecem os do titular
  store.commit('changeUserDados', { ...store.getters.userDados, licencas: json.data.licencas || [] });

  showToast('success', 'Empresa ativada!');
  // Full reload: reconstrói SignalR, heartbeat, configs e views em cache no contexto novo
  window.location.assign('/');
};

onMounted(async () => {
  const json = await listaEmpresas();
  if (json.ok) empresas.value = json.data || [];
});
</script>

<style scoped>
.empresa-nome {
  max-width: 180px;
  font-weight: 600;
}
.dropdown-item.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>
